import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { IReport } from '../../../models/IReport';
import { saveAs } from "file-saver";
import { get } from 'aws-amplify/api';


@Injectable({
    providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getReport(id: string): Observable<IReport> {
    const op = get({
      apiName: 'portal',
      path: `reports/${id}`,
      options: {}
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      map((data: any) => data as IReport),
      catchError((error) => throwError(() => error))
    );
  }

  getFlightReport(id: string): void {
    const fileName = id === 'flightArrivals' ? 'FlightArrivalReports' : 'FlightDepartureReports';
    const op = get({
      apiName: 'portal',
      path: `reports/${id}`,
      options: {
        queryParams: { download: '' } // matches ?download
      }
    });
    from(op.response.then(async (r) => (await r.body.json()) as any))
      .pipe(
        tap((payload: any) => this.save(payload?.data, fileName)),
        catchError((error) => throwError(() => error))
      )
      .subscribe();
  }
  getRegistrationStatusReport(id: string): void {
    const op = get({
      apiName: 'portal',
      path: `programs/${id}/registrationStatus`,
      options: { queryParams: { download: '' } }
    });
    from(op.response.then(async (r) => (await r.body.json()) as any))
      .pipe(
        tap((payload: any) => this.save(payload?.data, 'RegistrationStatusReports')),
        catchError((error) => throwError(() => error))
      )
      .subscribe();
  }
  getWellbeingCheckReport(programId: string, classId: string, reportName?: string): void {
    const op = get({
      apiName: 'portal',
      path: `programs/${programId}/courses/${classId}/participants`,
      options: { queryParams: { wellbeing: '' } } // matches ?wellbeing
    });
    from(op.response.then(async (r) => (await r.body.json()) as any))
      .pipe(
        tap((payload: any) => this.save(payload?.data, reportName || 'WellbeingCheckReports')),
        catchError((error) => throwError(() => error))
      )
      .subscribe();
  }
  geParticipantCheckReport(programId: string, classId: string, reportName?: string): void {
    const op = get({
      apiName: 'portal',
      path: `programs/${programId}/courses/${classId}/participants`,
      options: { queryParams: { download: '' } }
    });
    from(op.response.then(async (r) => (await r.body.json()) as any))
      .pipe(
        tap((payload: any) => this.save(payload?.data, reportName || 'ClassroomAttendanceReports')),
        catchError((error) => throwError(() => error))
      )
      .subscribe();
  }
  getEventReport(id: string, eventType: string, reportName?: string): void {
    const op = get({
      apiName: 'portal',
      path: `programs/${id}/download`,
      options: { queryParams: { eventType } }
    });
    from(op.response.then(async (r) => (await r.body.json()) as any))
      .pipe(
        tap((payload: any) => this.save(payload?.data, reportName || 'EventReports')),
        catchError((error) => throwError(() => error))
      )
      .subscribe();
  }
  private save(data: string, name: string): void {
    const dateString = new Date().toISOString().slice(0, 19).replace(/[^\d]/g, '');
    const fileName = name.replace(/[^\w\s-]/g, '');
    // payload.data is base64; keep your existing behavior
    const blob = new Blob([atob(data)], { type: 'text/csv' });
    saveAs(blob, `${fileName}_${dateString}.csv`);
  }
}


